"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizeWord = exports.mapLanguage = exports.isTranscriptTheSame = exports.getWords = exports.adjustTimings = void 0;
var _diff = require("diff");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var getWords = exports.getWords = function getWords(string) {
  var regex = new RegExp('([^\\s>]+(?![^<]*>))', 'ig');
  var result = string.replace(/&nbsp;/gi, ' ').match(regex);
  return result || [];
};
var normalizeWord = exports.normalizeWord = function normalizeWord(word) {
  return word.toLowerCase().replace(/\W/g, '');
};
var isTranscriptTheSame = exports.isTranscriptTheSame = function isTranscriptTheSame(transcriptA, transcriptB) {
  var normalizedA = transcriptA.toLowerCase().replace(/\W/g, ' ').replace(/\s+/g, ' ').trim();
  var normalizedB = transcriptB.toLowerCase().replace(/\W/g, ' ').replace(/\s+/g, ' ').trim();
  return normalizedA === normalizedB;
};
var adjustTimings = exports.adjustTimings = function adjustTimings(content, timings) {
  var gap = 10; // gap between words in ms
  var duration = 90; // default word duration in ms

  var words = getWords(content);

  // Convert start/end to number
  timings = timings.map(function (item) {
    return _objectSpread(_objectSpread({}, item), {}, {
      start: +item.start,
      end: +item.end
    });
  });
  var result;
  if (words.length === timings.length) {
    return timings.map(function (item, index) {
      return _objectSpread(_objectSpread({}, item), {}, {
        word: words[index]
      });
    });
  }
  var idealTimings = words.map(function (word) {
    return {
      word: word,
      start: -1,
      end: -1
    };
  });
  var diff = (0, _diff.diffArrays)(idealTimings, timings, {
    comparator: function comparator(a, b) {
      return normalizeWord(a.word) === normalizeWord(b.word);
    }
  });
  result = diff.reduce(function (array, el) {
    if (el.added) {
      return array;
    }
    return [].concat(_toConsumableArray(array), _toConsumableArray(el.value));
  }, []);

  // Calculate missing start/end points
  for (var i = 0; i < result.length; i++) {
    var item = result[i];
    if (item.start === -1) {
      var prev = result[i - 1];
      var next = result[i + 1];
      item.start = prev ? prev.end + gap : 0;
      item.end = next && next.start !== -1 ? next.start - gap : item.start + duration;
    }
  }
  result = result.map(function (item, index) {
    return _objectSpread(_objectSpread({}, item), {}, {
      word: words[index]
    });
  });
  return result;
};
var mapLanguage = exports.mapLanguage = function mapLanguage(language) {
  var mapper = {
    en: 'en-us'
  };
  if (language in mapper) {
    return mapper[language];
  }
  return language;
};